import {LandingHeading, LandingHero, LandingParagraph} from '@tempo/landing';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {useAuthLink} from '@app/hooks/use-link';

export const IndexHeroSection: React.FC = () => {
	const {t} = useTranslation();
	const {getRegistrationLink} = useAuthLink();
	return (
		<LandingHero>
			<LandingHeading as="h1">
				{t(
					'hubmomentslandingpage_title_deezerswithyouthroughkeymoments_standalone-web',
					{ns: 'moments'},
				)}
			</LandingHeading>
			<LandingParagraph>
				{t(
					'hubmomentslandingpage_text_deezerswithyouthroughkeymoments_standalone-web',
					{ns: 'moments'},
				)}
			</LandingParagraph>
			<LandingButtonLink
				tracking={{eventaction: 'signup'}}
				href={getRegistrationLink()}
				isMain
			>
				{t('generic_action_signupforfree_standalone-web', {ns: 'common'})}
			</LandingButtonLink>
		</LandingHero>
	);
};
